<template>
    <div >
        <banner     v-model:is-open="$data._openBanner"
                    :auto-hide="autoHide"
                    bg-color="bg-green-50"
                    fg-color="text-green-700">
            <template #icon>
                <!-- Heroicon name: check-circle -->
                <svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                </svg>
            </template>

            <template #title>
                <slot name="title">(Default) Success</slot></template>

            <template #content>
                <slot name="content">
                    <p><b>(Default)</b> Sweet Victory</p>
                </slot>
            </template>
        </banner>
    </div>
</template>

<script>
import Banner from "@/components/Banners/Banner"

export default {
    name: "BannerSuccess",
    mixins: [],
    components: { Banner },
    props: {
        isOpen: {
            type: Boolean,
            default: true,
        },
        autoHide: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            _openBanner: false,
        }
    },
    created() {
        this.$data._openBanner = this.isOpen
    },
    mounted() {

    },
    methods: {
    
    },
    watch: {
        isOpen(val, old) {
            if (val !== old) {
                this.$data._openBanner = this.isOpen
            }
        },
        _openBanner(val, old) {
            if (val !== old && this.$data._openBanner !== this.isOpen) {
                this.$emit('update:isOpen', this.$data._openBanner)
            }
        },
    },
    computed: {
    
    },
}
</script>